export default {
  login: '/',
  confirm: '/confirm/:code?',
  register: '/register',
  confirmation: '/register-confirmation',
  passwordRecovery: '/password-recovery',
  dashboard: '/dashboard',
  match: '/match/:id',
  changePassword: '/change-password/:code?',
  privateDocs: '/private-documents/:id',
  failure: '/failure',
  error: '/error',
};
